import { ApplicationContextStoreState } from '../types/application.types';

export const selectApplicationName = (state: ApplicationContextStoreState) =>
	state.applicationContext.applicationName;

export const selectGainsightLoadState = (state: ApplicationContextStoreState) =>
	!!state.applicationContext.isGainsightLoaded;
